// extracted by mini-css-extract-plugin
export default {"grid":"styles_grid__WN0OZ","switchWrapper":"styles_switchWrapper__saMqn","switches":"styles_switches__0iM-A","image":"styles_image__DFVaL"};